import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'trackType',
    pure: false,
    standalone: false
})
export class TrackTypeRenderer implements PipeTransform {

  constructor() {
  }

  transform(value: any): any {
    if(value == 'BREAK') {
      return 'Allgemein';
    } else if (value == 'INFO') {
      return 'Information';
    } else if (value == 'WORKSHOP') {
      return 'Workshop';
    }
  }

}
